export default __webpack_public_path__ + "static/media/plugPositivePlugged.f94ca700.svg";